<template>
    <div class="ur-context-box" v-show="isOpen" :style="contextStyle" v-click-outside.anchor="close">
        <slot/>
    </div>
</template>

<script>

    export default {
        name: 'ur-context-box',
        props: {
            // $ver: v0.2.0
            // 버튼의 모양을 결정합니다. String 형으로 solid, border, borderless, hyperlink에 대한 IDE 처리를 위해 추가되었습니다.
            // #Express Button as shape such as solid, border, borderless, hyperlink.
            // $tags IDE, shape
            shape: {type: String, default: undefined},


        },
        computed:{
            contextStyle(){
                let styles = {};
                styles['left'] = this.posX + 'px';
                styles['top'] = this.posY + 'px';
                return styles;
            }
        },
        data() {
            return {
                isOpen: false,
                posX: 0,
                posY: 0
            }
        },//v-click-outside.anchor="toggleItemOuter"
        methods: {
            open(event){
                this.posX = event.offsetX;
                this.posY = event.offsetY;
                this.isOpen = true;
                event.stopPropagation();
            },
            close(event){
                this.isOpen = false;
            }
        }
    };
</script>

<style scoped lang="scss">

</style>
